// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"d458406d","349":"0e02a245","453":"dcc38973","796":"d8b0df5f"}[chunkId] + ".chunk.js";
};